import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { SiteConfigService, ThemeStore } from '~/shared-common';
import { ClockComponent } from '~/shared-ui';
import { environment } from '../../../environments/environment';
import { AuthStore } from '../../stores/auth';
import { CloudTagListStore } from '../../stores/cloud-tag/cloud-tag-list.store';
@Component({
  selector: 'app-footer-B2B',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, ClockComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppFooterB2BComponent {
  private authStore = inject(AuthStore);
  private themeStore = inject(ThemeStore);
  private cloudTagListStore = inject(CloudTagListStore);
  siteConfigService = inject(SiteConfigService);
  $user = this.authStore.user;
  $activeObj = this.themeStore.activeObj;
  imgSrcUrl = `${environment.s3_url}/`;
  year: any = new Date().getFullYear();
  siteConfig = this.siteConfigService.getSiteConfig();
  constructor() {}
  init() {}
  displayImage(image_file: any) {
    if (!image_file || image_file == '') return '';
    if (image_file[0] == '/') {
      image_file = image_file.substring(1);
    }
    return this.imgSrcUrl + image_file;
  }
  ngOnInit() {}
}
